import React from 'react'

import DeleteIcon from 'Assets/Images/icons/delete'

export const ButtonDeleteInlineUnstyled = props => (
  <div
    className={`${props.className} link-delete`}
    onClick={props.onClickHandler || ''}
  >
    <DeleteIcon />
    {props.label}
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonDeleteInline/unstyled.js